import { MediasWidget } from '@/components/pages/analyze/widget/MediasWidget';
import { SIZE_FULL } from '@/lib/gridElements/size';

import type { WidgetType } from '@/lib/analytics/widget/widget.type';

export const mostEngagingPinsConfig: WidgetType<typeof MediasWidget> = {
    title: 'chart.pinterest.widget_most_engaging_pins',
    id: 'widget_most_engaging_pins',
    noSortTypesSelect: true,
    size: SIZE_FULL,
    sortFields: [
        'engagement_rate',
        'engagement_on_impression',
        'created',
        'reactions',
        'comments',
        'saves',
        'impressions'
    ],
    type: 'widget',
    element: MediasWidget
};
